import { client } from '../client';
import { WireDrawdownRequest } from '~/typings/API';
import { convertValues } from '~/util';

export type GetRequestType = {
  id: string;
};

const wireDrawdownRequestCast = (response: any): WireDrawdownRequest => ({
  ...response,
  amount: typeof response.amount === 'string' ? parseFloat(response.amount) : response.amount,
});

export class WireDrawdownRepository {
  static async get(request: GetRequestType) {
    return client
      .get<unknown, WireDrawdownRequest>(`/transfers/wire/drawdown/${request.id}`)
      .then((response) => convertValues<WireDrawdownRequest>(response, undefined, wireDrawdownRequestCast(response)));
  }
}
